import Fetch from '../../common/fetch'
import Tool from '../../common/tool'
import Storage from '../../common/storage'
import {
  Toast,
  Indicator
} from 'mint-ui'

// 加载数据
export function loadChartData(val, completion) {
  // 判断当前类型
  let type = Tool.query('type')
  if (parseInt(type) === 0) { // 您的小区
    loadCommunityInfo(val, function(data) {
      // body...
      completion(data, type)
    })
    return
  }

  if (parseInt(type) === 1) { // 商圈
    loadBusinessInfo(val, function(data) {
      // body...
      completion(data, type)
    })
    return
  }

  if (parseInt(type) === 2) { // 区县
    loadCountyInfo(val, function(data) {
      // body...
      completion(data, type)
    })
    return
  }

  if (parseInt(type) === 3) { // 全北京
    loadCityInfo(function(data) {
      // body...
      completion(data, type)
    })
    return
  }
}

// 加载全北京信息
function loadCityInfo(completion) {
  let userInfo = Storage.queryItem('userInfo')
  if (userInfo === null) {
    Toast({
      message: '请检查参数',
      position: 'middle',
      duration: 1000
    })
    return
  }
  // 创建参数
  let options = {
    openid: JSON.parse(userInfo).openid,
    token: JSON.parse(userInfo).token,
    city: '北京'
  }
  // 加载网络请求
  Indicator.open('加载中...')
  Fetch.loadCityDeal(options).then(function(resp) {
    console.log(resp)
    Indicator.close()
    if (resp.code === 0) {
      completion(resp.data)
    }
  }).catch(function(error) {
    Indicator.close()
    console.log(error)
  })
}

// 加载区县信息
function loadCountyInfo(district, completion) {
  let userInfo = Storage.queryItem('userInfo')
  if (userInfo === null) {
    Toast({
      message: '请检查参数',
      position: 'middle',
      duration: 1000
    })
    return
  }
  // 创建参数
  let options = {
    openid: JSON.parse(userInfo).openid,
    token: JSON.parse(userInfo).token,
    district: district
  }
  // 加载网络请求
  Indicator.open('加载中...')
  Fetch.loadCountySearch(options).then(function(resp) {
    console.log(resp)
    Indicator.close()
    if (resp.code === 0) {
      completion(resp.data)
    }
  }).catch(function(error) {
    Indicator.close()
    console.log(error)
  })
}

// 加载商圈信息
function loadBusinessInfo(bizcycle, completion) {
  let userInfo = Storage.queryItem('userInfo')
  if (userInfo === null) {
    Toast({
      message: '请检查参数',
      position: 'middle',
      duration: 1000
    })
    return
  }
  // 创建参数
  let options = {
    openid: JSON.parse(userInfo).openid,
    token: JSON.parse(userInfo).token,
    bizcycle: bizcycle
  }
  // 加载网络请求
  Indicator.open('加载中...')
  Fetch.loadBusinessSearch(options).then(function(resp) {
    console.log(resp)
    Indicator.close()
    if (resp.code === 0) {
      completion(resp.data)
    }
  }).catch(function(error) {
    Indicator.close()
    console.log(error)
  })
}

// 加载小区信息
function loadCommunityInfo(community, completion) {
  let userInfo = Storage.queryItem('userInfo')
  if (userInfo === null) {
    Toast({
      message: '请检查参数',
      position: 'middle',
      duration: 1000
    })
    return
  }
  // 创建参数
  let options = {
    openid: JSON.parse(userInfo).openid,
    token: JSON.parse(userInfo).token,
    community: community
  }
  // 加载网络请求
  Indicator.open('加载中...')
  Fetch.loadCommunitySearch(options).then(function(resp) {
    Indicator.close()
    if (resp.code === 0) {
      completion(resp.data)
    }
  }).catch(function(error) {
    Indicator.close()
    console.log(error)
  })
}



// WEBPACK FOOTER //
// ./src/components/ditribution/NIChart.js